<div class="page">
    <h1 class="mat-headline-4">{{ 'error.forbidden.noProductRight' | blah }}</h1>
    <div *ngIf="showAdmins"
        class="grid">
        <div [ngClass]="(!mobile)?'admins':'mobileAdmins'">
            <h2 class="mat-h2">{{ 'error.forbidden.pleaseContact' | blah }} {{ 'error.forbidden.adminUser' | blah }}
            </h2>
            <div class="mat-body"
                *ngFor="let user of portalUsers">
                <div>{{ user?.Name }}</div>
                <div style="margin-bottom: 16px;">
                    <a class="detailrow"
                        href="mailto:{{user?.Email}}"
                        *ngIf="user">
                        <mat-icon>email</mat-icon>
                        <a href="mailto:{{user?.Email}}">{{ user?.Email }}</a>
                    </a>
                    <mat-icon *ngIf="!user">email</mat-icon>
                    <a class="detailrow"
                        href="tel:{{user?.Phone}}"
                        *ngIf="user?.Phone">
                        <mat-icon>phone</mat-icon>
                        {{ user?.Phone }}
                    </a>
                    <mat-icon *ngIf="!user?.Phone">phone</mat-icon>
                </div>
            </div>
        </div>
        <div [ngClass]="(!mobile)?'support':'mobileSupport'">
            <h2 class="mat-h2">{{ 'default.or' | blah}} {{ 'error.forbidden.customerService' | blah }}</h2>
            <div class="mat-body">
                <a class="detailrow"
                    href="mailto:helpdesk@headpower.fi">
                    <mat-icon>email</mat-icon>helpdesk&#64;headpower.fi
                </a>
                <a class="detailrow"
                    href="tel:+358108415454">
                    <mat-icon>phone</mat-icon>010 - 841 5454
                </a>
            </div>
        </div>
    </div>
    <div *ngIf="!showAdmins">
        <h2 class="mat-h2">{{ 'error.forbidden.pleaseContact' | blah }}</h2>
        <div class="support">
            <h2 class="mat-h2">{{ 'error.forbidden.customerService' | blah }}</h2>
            <div class="mat-body">
                <a class="detailrow"
                    href="mailto:helpdesk@headpower.fi">
                    <mat-icon>email</mat-icon>helpdesk&#64;headpower.fi
                </a>
                <a class="detailrow"
                    href="tel:+358108415454">
                    <mat-icon>phone</mat-icon>010 - 841 5454
                </a>
            </div>
        </div>
    </div>
</div>